import { download } from '@/services/file.service.js'
import { appConfig } from '@/configs/appConfig.js'
import Cookies from 'js-cookie'

export const Pdf = axios => ({
  async download (slug, name, processSlug, previewLocale) {
    let url = `/v1/profiles/${slug}/pdf`
    if (processSlug) {
      url = `/v1/profiles/${slug}/pdf/${processSlug}`
    }

    const { data } = await axios({
      url,
      method: 'GET',
      responseType: 'blob',
      timeout: 120000,
      headers: {
        'X-locale': previewLocale || Cookies.get('locale')
      }
    })

    return download(data, name)
  },

  async get (slug, auth, system, locale, processSlug) {
    let url = `/v1/profiles/${slug}/preview`

    if (processSlug) {
      url = `/v1/profiles/${slug}/preview/${processSlug}`
    }

    return await axios.get(`${appConfig.pdfApiUrl}/api${url}`, {
      headers: {
        Authorization: `Bearer ${auth}`,
        XSystemType: system,
        'X-locale': locale,
        common: {}
      },
      params: {
        base64: true
      }
    })
  }
})
